"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.displayError = void 0;
const src_1 = require("..");
function displayError(message, section = '', term = '') {
    const onAction = (0, src_1.getOnAction)();
    const payload = { message, details: { section, term } };
    onAction && onAction(src_1.actionTypes.DISPLAY_ERROR, payload);
}
exports.displayError = displayError;
